import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api, { InviteTestUserCommand } from '../../api';

interface TestUserSliceState {}

const initialState: TestUserSliceState = {};

export const getTestUsers = createAsyncThunk(
  'testuser/getTestUsers',
  async (data: { projectId: number; pageNum: number; pageSize: number }) => {
    return await api.getProjectTestUsers(
      data.projectId,
      data.pageNum,
      data.pageSize,
    );
  },
);

export const deleteTestUser = createAsyncThunk(
  'testuser/deleteTestUser',
  async (data: { id: number; projectId: number }) => {
    return await api.deleteProjectTestUser(data.id, data.projectId);
  },
);

export const inviteTestUsers = createAsyncThunk(
  'testuser/inviteTestUsers',
  async (command: InviteTestUserCommand | undefined) => {
    return await api.inviteProjectTestUsers(command);
  },
);

export const acceptTestInvitation = createAsyncThunk(
  'testuser/acceptInvitation',
  async (invitationId: number) => {
    return await api.acceptTestInvitation(invitationId);
  }
)

const testuserSlice = createSlice({
  name: 'testuser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

const { reducer } = testuserSlice;

export default reducer;
